import type {
    UpdateCommerceCheckoutItemPurchaseRequest,
    UpdateCommerceCheckoutItemPurchaseResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const updateCommerceCheckoutItemPurchaseOperation = defineCommerceOperation<
    UpdateCommerceCheckoutItemPurchaseRequest,
    UpdateCommerceCheckoutItemPurchaseResponse
>("commerce.checkout.items.update-purchase");
